import { render } from "./InspectionTabBar.vue?vue&type=template&id=522bdf94"
import script from "./InspectionTabBar.vue?vue&type=script&lang=js"
export * from "./InspectionTabBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__